import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueAuthorize from '@swoop-ltd/vue-authorize'
import VueInstant from '@swoop-ltd/vue-instant'
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'
import Vuebar from 'vuebar'
import VShowSlide from 'v-show-slide'
import { VPopover } from 'v-tooltip'
import Toasted from 'vue-toasted'
import { Buffer } from 'buffer'

import router from './router'
import App from './App.vue'

import store from '@/store'
import Icon from '@/config/vue-awesome'
import roles from '@/config/roles'
import permissions from '@/config/permissions'
import initVeeValidations from '@/config/vee-validate.validations'
import Meta from 'vue-meta'
import { i18n } from '@/config/vue-i18n'

import registerDirectives from '@/directives'
import registerFilters from '@/filters'
import { initSentry } from '@/config/sentry'

import './assets/styles/variables.css'
import '@/assets/styles/index.scss'
import GenericButton from '@/components/GenericButton.vue'

// Enable Buffer polyfill
// https://github.com/vitejs/vite/discussions/2785
window.Buffer = Buffer

// Setup vue config
Vue.config.productionTip = false

// Setup vue middlewares
Vue.use(VueAxios, axios)
Vue.use(VueAuthorize, {
  roles,
  permissions
})
Vue.use(VueInstant)
Vue.use(VModal)
Vue.use(Notifications)

Vue.component('GenericButton', GenericButton)
Vue.use(Vuebar)
Vue.use(VShowSlide)
Vue.use(Toasted)
Vue.use(Meta)

initSentry()

// Init vee-validate validations
initVeeValidations()

// Declare global custom components
Vue.component('icon', Icon)
Vue.component('popover', VPopover)
// Declare global directives
registerDirectives(Vue)

// Declare global filters
registerFilters(Vue)

function createApp() {
  // eslint-disable-next-line no-unused-vars
  return new Vue({
    i18n,
    el: '#swoop-root',
    router,
    store,
    render: h => h(App),
    mounted() {
      document.dispatchEvent(new Event('render-event'))
    }
  })
}

createApp()
